module.exports = __webpack_public_path__ + "static/media/34.6631bdf0.png";